/**
 * @license
 * @copyright Copyright Motili Inc., 2023 All Rights Reserved
 */

import RegistrationComplete from './RegistrationComplete';

export default function RegistrationCompletionPage() {
    return <RegistrationComplete />;
}
